import axios, { AxiosInstance } from 'axios';
import {IConfiguration} from '@gishub/domain';

export class AxiosClient {
  private static instance: AxiosInstance | null = null;

  static setApiUrl(configuration: IConfiguration): void {
    AxiosClient.instance = axios.create({
      baseURL: configuration.apiUrl,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    AxiosClient.instance.interceptors.request.use(
      (config) => config,
      (error) => Promise.reject(error)
    );

    AxiosClient.instance.interceptors.response.use(
      (response) => response,
      (error) => {
        const responseData = error.response?.data;

        const apiError = {
          ...responseData,                                                        // message, success y cualquier campo del body directo
          message: responseData?.message ?? error.message ?? 'Error de conexión', // garantiza que siempre haya message
          status: error.response?.status,
          url: error.config?.url,
          method: error.config?.method?.toUpperCase(),
        };

        console.error(`[Axios Error] ${apiError.status} ${apiError.method} ${apiError.url}:`, apiError.message);

        return Promise.reject(apiError);
      }
    );
  }

  static getInstance(): AxiosInstance {
    return AxiosClient.instance!;
  }
}

export const axiosClient = new Proxy({} as AxiosInstance, {
  get(_, prop: string): any {
    const instance = AxiosClient.getInstance();
    return (instance as any)[prop];
  }
}) as AxiosInstance;